import { render } from "./AdminFileManager.vue?vue&type=template&id=bae81680"
import script from "./AdminFileManager.vue?vue&type=script&lang=js"
export * from "./AdminFileManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__